import { useQuery, useMutation, queryCache } from 'react-query'
import { AddFeatureParams, UpdateFeatureParams } from 'models/layer'
import { LayerRepository } from 'repository/layer'
import { InfowindowData } from 'models/infowindow'

export const useFetchLayers = (options?: any) => {
  const { status, data, error } = useQuery('layers', LayerRepository.fetchAll, options)

  return {
    status,
    layers: data,
    error,
  }
}

export const useFetchLayer = (layerId: number, options?: any) => {
  const { layers, status, error } = useFetchLayers()
  const layer = layers
    ?.flatMap((layerGroup) => layerGroup.layers)
    .find((layer) => layer.id === parseInt(layerId as any))!

  return { layer, status, error }
}

export const useAddFeature = (layerId: number) => {
  return useMutation((data: AddFeatureParams) => LayerRepository.addFeature(layerId, data), {
    onSuccess: (infowindow: InfowindowData) => {
      queryCache.setQueryData(['infowindow', { id: infowindow.id.toString() }], infowindow)
    },
  })
}

export const useUpdateFeature = (layerId: number, featureId: number) => {
  return useMutation(
    (data: UpdateFeatureParams) => LayerRepository.updateFeature(layerId, featureId, data),
    {
      onSuccess: (infowindow: InfowindowData) => {
        queryCache.setQueryData(['infowindow', { id: featureId }], infowindow)
      },
    },
  )
}

export const useDeleteFeature = (layerId: number, featureId: number) => {
  return useMutation(() => LayerRepository.deleteFeature(layerId, featureId), {
    onSuccess: () => {
      queryCache.removeQueries(['infowindow', { id: featureId }])
    },
  })
}
